module.exports = __webpack_public_path__ + "static/media/eth.5fc0c9bd.png";